import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Textarea from 'react-textarea-autosize';

import AutoSuggestText from '../../../../components/AutoSuggestText/index';
import styles from './feelingForm.module.css';
import Dropdown from '../Dropdown';
import { useAppointmentStore } from 'store/mobx/mobx';
import Loading from 'components/loadingSpinner';
import { set } from 'react-ga';

const FeelingForm = observer(
  ({
    postService,
    sessionDetails,
    Services,
    SelectedService,
    isFetching,
    Symptoms,
    SelectedSymptoms,
    changeReason,
    showWarning,
    warningMessage,
    note,
    changeService,
    onChange,
    reasons,
    methods,
    consult,
    setMethod,
    showServiceQuestionnaire,
  }) => {
    const store = useAppointmentStore();
    const [selected, setSelected] = useState(false);
    const [idCount, setIdCount] = useState(2);
    const [showConsult, setShowConsult] = useState(consult);
    const [filterConsultMethods, setFilterConsultMethods] = useState(methods);

    const [symptomValues, setSymptomValues] = useState([]);
    const [inputObjects, setInputObjects] = useState([
      {
        id: 0,
        reasonIndex: 0,
        changeValue: changeReason,
        selected: false,
        items: Symptoms,
        placeholder: 'Choose the symptoms you are experiencing',
        removeDisplayNone: removeDisplayNone,
        toggle: addDisplayNone,
        shiftBoxes: shiftBoxes,
        removeSymptomValue: removeSymptomValue,
        addSymptomValue: addSymptomValue,
      },
      {
        id: 1,
        reasonIndex: 1,
        changeValue: changeReason,
        selected: false,
        items: Symptoms,
        placeholder: '+ Add',
        removeDisplayNone: removeDisplayNone,
        toggle: addDisplayNone,
        selectedState: false,
        removeSymptomValue: removeSymptomValue,
        addSymptomValue: addSymptomValue,
      },
    ]);

    const removeDisplayNone = () => {
      setSelected(true);
    };

    const addDisplayNone = () => {
      setSelected(false);
    };

    const addSymptomValue = val => {
      let arr = symptomValues;

      arr.push(val);
      setSymptomValues(arr);
    };

    const removeSymptomValue = element => {
      let arr = symptomValues;

      element === 0 ? arr.shift() : arr.pop();
      setSymptomValues(arr);
    };

    const shiftBoxes = () => {
      let boxes = inputObjects;
      boxes.shift();
      boxes[0].reasonIndex = 0;
      boxes[0].placeholder = 'Choose the symptoms you are experiencing';
      boxes[0].removeDisplayNone = removeDisplayNone;
      boxes[0].toggle = addDisplayNone;
      boxes[0].shiftBoxes = shiftBoxes;

      boxes.push({
        id: idCount,
        reasonIndex: 1,
        changeValue: changeReason,
        selected: false,
        items: Symptoms,
        placeholder: '+ Add',
        removeDisplayNone: () => {},
        toggle: () => {},
        selectedState: false,
        removeSymptomValue: removeSymptomValue,
        addSymptomValue: addSymptomValue,
      });

      setIdCount(idCount + 1);
      setInputObjects(boxes);
    };

    function offeredConsultMethodOnly(method) {
      if (SelectedService.ConsultMethod)
        return method === SelectedService.ConsultMethod;
      else return true;
    }

    useEffect(() => {
      if (methods && SelectedService) {
        let filteredMethods = methods.filter(method =>
          offeredConsultMethodOnly(method.Code),
        );
        setFilterConsultMethods(filteredMethods);
        setShowConsult(filteredMethods.length > 1);
        if (filteredMethods.length === 1) {
          setMethod(filteredMethods[0].Code);
        }
      }

      if (methods && !SelectedService) {
        setShowConsult(false);
      }
    }, [SelectedService]);

    let classnames =
      symptomValues.length > 0 ? styles.optionVisible : styles.displayNone;
    return (
      <div className={styles.container}>
        <form className={styles.feelingForm}>
          <Loading
            isFetching={isFetching}
            style={{ fill: '#07A3C8', width: '100%' }}
          />
          {showWarning && (
            <div className={styles.redBorder}>
              {warningMessage.map((item, i) => {
                return (
                  <div key={i} className={styles.redColor}>
                    {item}
                  </div>
                );
              })}
            </div>
          )}
          {!showWarning && !showServiceQuestionnaire && (
            <div>
              <br></br>
              <br></br>
              <br></br>
            </div>
          )}
          <div className={styles.question}>
            What service do you require today? (You must choose 1)
          </div>
          <AutoSuggestText
            changeValue={changeService}
            _selected={SelectedService}
            items={Services}
            placeholder={'Select your required service'}
            removeDisplayNone={() => {}}
            toggle={() => {}}
            removeSymptomValue={() => {}}
            addSymptomValue={() => {}}
            postItem={postService}
            reasonIndex={null}
            top={'40px'}
          />

          {!showServiceQuestionnaire && (
            <div className={styles.question}>
              What symptoms are you experiencing (Choose up to 2)
            </div>
          )}
          {!showServiceQuestionnaire && (
            <div className={styles.questionContainer}>
              {Symptoms &&
                inputObjects.map(item => (
                  <div
                    key={item.id}
                    className={
                      item.reasonIndex === 1
                        ? classnames
                        : symptomValues.length === 0
                        ? styles.normal
                        : ''
                    }
                  >
                    <AutoSuggestText
                      key={item.id}
                      reasonIndex={item.reasonIndex}
                      changeValue={item.changeValue}
                      _selected={SelectedSymptoms[item.reasonIndex]}
                      items={Symptoms}
                      placeholder={item.placeholder}
                      removeDisplayNone={removeDisplayNone}
                      toggle={addDisplayNone}
                      shiftBoxes={shiftBoxes}
                      addSymptomValue={addSymptomValue}
                      removeSymptomValue={removeSymptomValue}
                    />
                  </div>
                ))}
            </div>
          )}

          {filterConsultMethods && showConsult && (
            <div>
              <div className={styles.question}>What type of appointment?</div>
              <Dropdown
                items={filterConsultMethods}
                setMethod={method => setMethod(method)}
              />
            </div>
          )}
          <Textarea
            placeholder="Provide a brief reason for your visit"
            value={note}
            onChange={onChange}
            className={styles.textarea}
            maxLength={120}
          />
        </form>
      </div>
    );
  },
);

export default FeelingForm;
